module.exports = __webpack_public_path__ + "assets/img/empty1.98494e85.png";